import type { ColorPalette } from '../ColorPalette';
import { AbstractMode } from './AbstractMode';
import type { ModeInterface } from './ModeInterface';

const MAX_TIMEOUT_MS = 2147483647;

/**
 * Rotating palette mode (appearance preset: rotate).
 */
export class RotateColorMode extends AbstractMode implements ModeInterface {
	private readonly intervalSeconds: number;

	private index = 0;
	private timeoutId: ReturnType<typeof setTimeout> | null = null;

	constructor(
		private readonly palettes: ColorPalette[],
		intervalSeconds: number
	) {
		super();
		this.intervalSeconds = Math.max(1, intervalSeconds);
		console.log('[RotateColorMode] init', { palettes: palettes.map((p) => p.key()), intervalSeconds: this.intervalSeconds });
		this.scheduleNextBoundary();
	}

	currentPalette(): ColorPalette {
		const count = this.palettes.length;
		if (count < 1) {
			console.error('RotateColorMode requires at least one palette.');
		}

		return this.palettes[this.index % count];
	}

	type(): string {
		return 'rotator';
	}

	protected onDispose(): void {
		if (this.timeoutId !== null) {
			clearTimeout(this.timeoutId);
			this.timeoutId = null;
		}
	}

	private scheduleNextBoundary(): void {
		const count = this.palettes.length;
		console.log('[RotateColorMode] scheduling next rotation in', this.intervalSeconds, 's, current index:', this.index, '→', this.palettes[this.index % count]?.key());

		this.timeoutId = setTimeout(() => {
			this.timeoutId = null;
			this.index = (this.index + 1) % count;
			console.log('[RotateColorMode] rotating to index', this.index, '→', this.palettes[this.index]?.key());
			this.notifyPaletteStale();
			this.scheduleNextBoundary();
		}, this.intervalSeconds * 1000);
	}
}
